import 'datatables.net-bs5';
import endless from "./eo/endless";

export default class {
    static init = () => {
        endless.init();
    }
}
